import ChoicesJS from 'choices.js';

export default {
    init() {
        this.initSelectFields();
    },
    initSelectFields() {
        jQuery(document).on('nfFormReady', function() {
            // Ninja Forms is Ready

            if (document.querySelector('.js-choices')) {
                Array.from(document.querySelectorAll('.js-choices'))
                    .forEach(field => {
                        field.choices = new ChoicesJS(field, {
                            allowHTML: true,
                            shouldSort: false
                        });
                    });
            }
        });
    }
}
